// extracted by mini-css-extract-plugin
export var arrows = "_2u-6";
export var decrementer = "_2u-a";
export var disabled = "_2u-4";
export var error = "_2u-1";
export var hiddenText = "_2u-b";
export var incrementer = "_2u-9";
export var input = "_2u-8";
export var inputWrapper = "_2u-0";
export var leadingIcon = "_2u-c";
export var readonly = "_2u-3";
export var regular = "_2u-7";
export var small = "_2u-5";
export var warning = "_2u-2";